export default "__VITE_ASSET__Dowb56pO__"